import { render, staticRenderFns } from "./ContentFeedGrid.vue?vue&type=template&id=5cab3508&scoped=true&"
import script from "./ContentFeedGrid.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedGrid.vue?vue&type=style&index=0&id=5cab3508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab3508",
  null
  
)

export default component.exports